export type DataType = 'Date' | 'Time' | 'DateTime' | 'DateTimeOffset' | 'DateOnly' | 'Decimal' | 'Int32' | 'String' | 'Guid' | 'Empty' | 'StringDate' | 'Boolean';
export type NumberFilter = 'greater_than' | 'less_than' | 'greater_than_or_equal' | 'less_than_or_equal' | 'equal' | 'not_equal' | 'between' | 'empty';
export type StringFilter = 'equal' | 'not_equal' | 'includes' | 'not_includes' | 'empty';

export enum FilterType {
    number,
    string,
    date,
    boolean
}
export interface AdvancedFilterConfig {
    bootgridId: string;
    filterComponents: FilterConfig[];
}
export interface FilterConfig {
    selectedColumn: string;
    selectedFilter: string;
    filterValues: string[];
}
export interface Column {
    id: any;
    identifier: boolean;
    converter: any;
    text: string;
    align: string;
    headerAlign: string;
    cssClass: string;
    headerCssClass: string;
    formatter: any | null;
    dataType: DataType;
    order: string | null;
    searchable: boolean;
    sortable: boolean;
    visible: boolean;
    width: string | null;
    searchPhrase: string | null;
}
export interface PageState {
    selectedSubMenuItemId: string;
    selectedPageView: string;
    selectedGridViews: Record<string, string>;
    selectedRows: Record<string, string>;
}
export interface ColumnFilter {
    ColumnName: string;
    DataType: DataType;
    FilterValue: NumberFilter | StringFilter;
    Values: string[];
}
export interface Filter {
    searchPhrase: string;
    columnFilters: ColumnFilter[];
    columnSort: Record<string, string>;
    rowCount: string;
    currentPage: string;
    displayedColumns: { columnId: string, dataType: DataType }[];
}
export enum BootgridChangeType {
    select = 'Select',
    deselect = 'Deselect',
    search = 'Search',
    update = 'Update',
}
